import React, { useEffect, useState } from 'react';
import RegistryDetails from '../components/registry-details/RegistryDetails';
import { useParams } from 'react-router-dom';
import { Container, Grid, Typography } from '@mui/material';
import SingleProduct from '../components/registry-details/SingleProduct';
import Filters from '../components/registry-details/Filters';
import { getRegistry } from '../api/products';
import ScreenLoading from '../components/Loading/pageLoading';

const Registry = () => {
  const { registryUrl } = useParams();
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState('available');
  const [price, setPrice] = useState(' ');
  const [registryData, setRegistryData] = useState(null);

  const fetchRegistryData = async () => {
    try {
      setLoading(true);
      const params = {
        registryUrl,
        status: type,
        price: price,
      };
      const response = await getRegistry(params);
      if (!response.ok) {
        throw new Error(
          `Failed to fetch registry data: ${response.statusText}`
        );
      }

      const data = await response.json();
      setRegistryData(data);
    } catch (error) {
      console.error('Error fetching registry data:', error.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchRegistryData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registryUrl, type, price]);

  return (
    <>
    {loading && <ScreenLoading />}
      <Grid
        container
        sx={{ backgroundColor: '#EFEAE4', margin: '0 auto' }}>
        {registryUrl && registryData ? (
          <>
            <RegistryDetails registryData={registryData} />
            <Filters
              registryData={registryData}
              type={type}
              setType={setType}
              price={price}
              setPrice={setPrice}
            />
            {
            registryData.products &&
            registryData.products.length > 0 ? (
              <SingleProduct
                products={registryData.products}
                registryId={registryData.id}
                fetchRegistryData={fetchRegistryData}
                type={type}
                loading={loading}
              />
            ) : type === 'purchased' ? (
              <Container>
                <Grid
                  sx={{
                    borderRadius: 2,
                    bgcolor: '#ffffff',
                    border: '1px solid #000000',
                    padding: '32px',
                    my: '80px',
                    textAlign: 'center',
                  }}>
                  <Typography variant="body1" sx={{ mt: 2 }}>
                    👀 Nothing to see here yet. Be the first one to buy
                    something!
                  </Typography>
                </Grid>
              </Container>
            ) : (
              <Container>
                <Grid
                  sx={{
                    borderRadius: 2,
                    bgcolor: '#ffffff',
                    border: '1px solid #000000',
                    padding: '32px',
                    my: '80px',
                    textAlign: 'center',
                  }}>
                  <Typography variant="body1" sx={{ mt: 2 }}>
                    👀 Nothing to see here yet.
                  </Typography>
                </Grid>
              </Container>
            )}
          </>
        ) : (
          <ScreenLoading />
        )}
      </Grid>
    </>
  );
};

export default Registry;
